<template lang="pug">
.caseDialogue(v-disabled="seeState")
  .Dialogue-box
    Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;margin-left: 12px;transform: translateY(-10px);',
      @click='showAIDialog()',v-if='enableAI') AI生成
    Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
      Form(:model="aiForm" :label-width="80")
        FormItem(label="生成数量")
          InputNumber(v-model="aiForm.count" :min="1" :max="10" placeholder="请输入生成数量")
        FormItem(label="对话轮数")
          InputNumber(v-model="aiForm.dialogue_count" :min="1" :max="10" placeholder="请输入对话轮数")
        FormItem(label='提示词',prop="stem")
          Input(v-model='aiForm.system' placeholder='请填写提示词'
            type="textarea" :rows="3")
    Form(:model="question")
      FormItem(label="1." :label-width="80")
        Row(:gutter="16")
          Col(span="8")
            Input(type='text',placeholder='请输入题目',v-model='question.stem' :maxlength="50")
          Col(span="14")
            iDelModel.del(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
      div
        div(v-for="(app,index) in question.metas" :key="app.key")
          FormItem(:label="`#问题${index + 1}`" :label-width="80")
            Row(:gutter="16")
              Col(span="16")
                Input(type='text',placeholder='请输入题目' v-model="app.question" :maxlength="30")
              Col(span="4")
                Button(v-if="index != 0" type="error" shape="circle" icon="md-close" size="small" @click="handleDelParent(index)")
            Row(style="margin-top:20px;padding:0 8px;")
              quillEditor(ref="myQuillEditor" :options="editorOption" v-model="app.answer")
          FormItem(label="" :label-width="80")
            Button(type="primary" ghost @click="handleAddParent") + 添加问题
            Row(v-for="(val,i) in app.extraQuestionsList" :key="val.key" :gutter="16" style="margin-top:10px;")
              FormItem(:label="`#追问${i + 1}`" :label-width="80")
                Col(span="16")
                  Input(type='text',placeholder='请输入题目' v-model="val.question" :maxlength="30")
                Col(span="4")
                  Button(v-if="i != 0" type="error" shape="circle" icon="md-close" size="small" @click="handleDelChild(index,i)")
              FormItem(label=" " :label-width="80")
                Col(span="16")
                  div(style="padding:0 8px;margin-top:20px")
                    quillEditor(ref="myQuillEditor2" :options="editorOption" v-model="val.answer")
              FormItem(label=" " :label-width="80")
                Col(span="16")
                  div(style="padding:0 8px;margin-top:20px")
                    Button(type="primary" ghost @click="handleAddChild(index)") + 添加追问问题
            //- Button(type="error" shape="circle" icon="md-close" size="small")
      //-     Button.button(@click='addMeta2',
      //- style='color:#3A76D2;border: 1px solid #3A76D2;text-align:left;margin-left: 0px;') + 添加分析师讲话
</template>

<script>
import iDelModel from "@/components/common/iDelModel";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Bus from "../../utils/bus";
export default {
  components: {
    iDelModel,
    quillEditor
  },
  props: ["data", "haId", "taskId", "enableAI"],
  inject: ["seeState"],

  data() {
    return {
      aiDialogVisible: false,
      aiForm: {},
      editorOption: {
        placeholder: "请输入",
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "image",
              "link",
              { indent: "-1" },
              { indent: "+1" },
              { align: "" },
              { align: "center" },
              { align: "right" },
              { color: [] },
              { background: [] },
              {
                font: [
                  "SimSun",
                  "SimHei",
                  "Microsoft-YaHei",
                  "KaiTi",
                  "FangSong",
                  "Arial",
                  "sans-serif"
                ]
              },
              { size: ["small", false, "large", "huge"] }
            ]
          ]
        }
      },
      question: {
        stem: "",
        metas: [
          {
            question: "",
            answer: "",
            key: "z",
            extraQuestionsList: [
              {
                key: "a",
                question: "",
                answer: ""
              }
            ] // 追加问题列表
          }
        ],
        scoringKeywords: ["暂无"] // 评分关键词
      }
    };
  },
  methods: {
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { count: 1, dialogue_count: 1, system: "" };
    },
    generateCase() {
      if (this.taskId === "" || this.taskId === null || this.taskId === undefined) {
        this.$Message.error("无法生成！原因：需先保存当前场景！");
        return;
      }
      const data = {
        inputs: {
          opt_type: "ASKANDANSWER",
          count: this.aiForm.count,
          dialogue_count: this.aiForm.dialogue_count,
          pyId: this.$store.state.Case.basic.id,
          tsId: this.taskId,
          haId: this.haId,
          score: 2,
          system: this.aiForm.system
        }
      };
      this.$http.generateCase(data).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          if (this.taskId !== this.haId) {
              Bus.$emit("refresh-task", this.taskId);
          } else {
              this.$emit("refresh-query");
          }
        }
      });
    },
    handleAddParent() {
      if (this.question.metas.length > 9) {
        this.$Message.warning("问题最多添加10条！");
        return;
      }
      this.question.metas.push({
        question: "",
        answer: "",
        key: Math.floor(Math.random() * 1000000).toString(),
        extraQuestionsList: [
          {
            key: Math.floor(Math.random() * 1000000).toString(),
            question: "",
            answer: ""
          }
        ]
      });
    },
    handleAddChild(index) {
      if (this.question.metas[index].extraQuestionsList.length > 4) {
        this.$Message.warning("追问最多添加5条！");
        return;
      }
      this.question.metas[index].extraQuestionsList.push({
        key: Math.floor(Math.random() * 1000000).toString(),
        question: "",
        answer: ""
      });
    },
    handleDelChild(parIndex, index) {
      this.question.metas[parIndex].extraQuestionsList = this.question.metas[
        parIndex
      ].extraQuestionsList.filter((val, i) => i !== index);
    },
    handleDelParent(index) {
      this.question.metas = this.question.metas.filter((val, i) => i !== index);
    },
    // 删除
    delModel() {
      this.$emit("delModel");
    }
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      //   this.$emit("data1:data", this.question);
    });
  }
};
</script>

<style lang="stylus">
.ivu-input-default
  margin 0!important
</style>
